// extracted by mini-css-extract-plugin
export default {"container":"ToggleInput_container__ETim6","switch":"ToggleInput_switch__64IXJ","slider":"ToggleInput_slider__tkscZ","round":"ToggleInput_round__fEtpo"};